import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      © 2025 Las Casitas – Prototipo académico para la asignatura
      "Sistemas de Información en la Organización".
    </footer>
  );
}

export default Footer;